module.exports = __webpack_public_path__ + "img/dlt.b8ecc25e.png";